import React from 'react';
import { Step } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { saveStates, states } from '@/constants/lifecycle';
import WizardStep from '@/components/wizard/WizardStep';
import { datasetSteps } from '../constants';
import { compactStepIndexes } from '../helper';
import { allowedDatasetStepIndexes, datasetSourceAndStepAttributes, datasetStepNames } from '../state/state';
import { resolveCatalogueTemplate } from '../catalogue/helper';
import { datasetPerms } from '../sharing/state/state';

const DatasetSteps = ({
  activeStepIndex,
  compact,
  disableEdit,
  goToStep,
  indexes,
  saveStatus,
  sections,
}) => {
  const activeStep = Object.values(datasetSteps)[activeStepIndex].name;
  const steps = Object.values(datasetSteps);
  const names = datasetStepNames(datasetSteps);
  return (
    <Step.Group
      fluid={compact}
      size={compact ? 'mini' : 'tiny'}
      vertical={!compact}
      className="aridhia-dataset-steps"
    >
      {indexes.map((i) => (
        <WizardStep
          activeStep={activeStep}
          disabled={saveStatus === states.PENDING || disableEdit}
          description={steps[i].isSection ? sections[steps[i].name].label : undefined}
          entity={steps[i].isSection ? undefined : 'dataset'}
          icon={steps[i].icon}
          index={i}
          key={`dataset_step${steps[i].name}`}
          onClick={goToStep}
          steps={names}
        />
      ))}
    </Step.Group>
  );
};

const mapStateToProps = ({
  auth: { role: { permissions: { attachments } } },
  catalogues: { templates },
  datasets: { datasets },
  datasetDatasource: { features },
}, ownProps) => {
  const { dataset, template, editable } = resolveCatalogueTemplate(datasets, templates, ownProps, {
    permissions: datasetPerms(),
    ...saveStates,
    steps: datasetSourceAndStepAttributes(),
  }, features);
  const allowAttachments = attachments.create;
  const indexes = ownProps.compact ? compactStepIndexes(dataset, template, allowAttachments)
    : allowedDatasetStepIndexes(dataset, template, allowAttachments);

  return ({
    activeStepIndex: dataset.steps.activeStepIndex,
    disableEdit: !editable,
    indexes,
    saveStatus: dataset.saveStatus,
    sections: template.sections,
  });
};

export default connect(mapStateToProps)(DatasetSteps);
